import React from 'react';
import PropTypes from 'prop-types';
import SVG from '../icons';

export default class Icon extends React.Component {
  static defaultProps = {
    className: 'icon',
    type: 'svg',
    width: 100,
    height: 100
  };

  static propTypes = {
    className: PropTypes.string.isRequired,
    src: PropTypes.string.isRequired,
    type: PropTypes.string.isRequired,
    width: PropTypes.number,
    height: PropTypes.number,
    theme: PropTypes.string,

  };

  constructor() {
    super();

    this.TYPE = {
      SVG: 'svg'
    };
  }

  render() {
    const { className, src, type, width, height } = this.props;
    const { TYPE } = this;
    const InlineSVG = SVG[src] || "";//Prevent error when src is missing in SVG

    return (
      <React.Fragment>
        {type === TYPE.SVG ? (
          InlineSVG && <InlineSVG className={`icon ${className !== '' ? `icon-${className}` : ''}`} {...this.props} />
        ) : (
            <image
              className={`icon ${className !== '' ? `icon-${className}` : ''}`}
              href={src}
              x="0"
              y="0"
              width={width}
              height={height}
            />
          )}
      </React.Fragment>
    );
  }
}
